import styled from 'styled-components'

export const StyledTokenRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin: 8px 0;
  width: 100%;
`

export const StyledTokenLabel = styled.div`
  margin-left: 13px;
`

export const StyledTokenIcon = styled.img`
  border: 1px solid #eff0fa;
  border-radius: 50%;
  flex: 0 0 28px;
  height: 28px;
  margin-right: 13px;
  width: 28px;
`

export const StyledTokenValue = styled.div`
  color: #9598ab;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`

export const StyledTokenAmount = styled.div`
  color: #191c1e;
  font-size: 20px;
  font-weight: 500;
  line-height: 120%;
`
